import { render, staticRenderFns } from "./IframeTemplateNew.vue?vue&type=template&id=5830320e&scoped=true&"
import script from "./IframeTemplateNew.vue?vue&type=script&lang=js&"
export * from "./IframeTemplateNew.vue?vue&type=script&lang=js&"
import style0 from "./IframeTemplateNew.vue?vue&type=style&index=0&id=5830320e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5830320e",
  null
  
)

export default component.exports